import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { messages } from '../messages';
import style from '../select-products-table.module.less';

export const createNameColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'name',
  Header: <FormattedMessage {...messages.nameColumnHeader} />,
  width: 2,
  className: style['name-cell'],
  isSortable: true,
});
